import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=16307435&scoped=true"
import script from "./TableForm.vue?vue&type=script&lang=js"
export * from "./TableForm.vue?vue&type=script&lang=js"
import style0 from "./TableForm.vue?vue&type=style&index=0&id=16307435&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16307435",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16307435')) {
      api.createRecord('16307435', component.options)
    } else {
      api.reload('16307435', component.options)
    }
    module.hot.accept("./TableForm.vue?vue&type=template&id=16307435&scoped=true", function () {
      api.rerender('16307435', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/database/datatable/TableForm.vue"
export default component.exports